import { createSlice } from '@reduxjs/toolkit'

export const queryParamsSlice = createSlice({
  name: 'pageLoad',
  initialState: {
    baseUrl: '',
    account: '',
    user: '',
    workflowGroupName: '',
    template: '',
    page: '',
    tab: '',
    lang: 'en', //default en if none given
    loadTemplateOnLanding: false,
    token: ""
  },
  reducers: {
    setQueryParams: (state, action) => {
      //baseUrl required. check for empty string to set params once per pageload
      if (state.baseUrl === '') {
        ["baseUrl", "account", "user", "workflowGroupName", "template", "page", "tab", "lang", "token"]
        .forEach((o, k) => state[o] = action.payload[o]);
      }
    },
    setLoadTemplateOnLanding: (state, action) => {
      state.loadTemplateOnLanding = action.payload;
    },
  },
})

// Action creators are generated for each case reducer function
export const { setQueryParams, setLoadTemplateOnLanding } = queryParamsSlice.actions

export default queryParamsSlice.reducer
